
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { HeaderUserMenuComponent } from '../header-user-menu/header-user-menu.component';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { AuthService } from '@shared/services/auth/auth.service';
import { StorageService } from '@shared/services/storage/storage.service';
import { STORAGE } from '@shared/constants/storage.constants';
import { buildUrl } from '@shared/utilities/common.utils';
import { HeaderAccountingPeriodComponent } from '../header-accounting-period/header-accounting-period.component';
import { HeaderReminderComponent } from "../header-reminder/header-reminder.component";

@Component({
  selector: 'avenir-header',
  standalone: true,
  imports: [
    RouterModule,
    HeaderUserMenuComponent,
    HeaderAccountingPeriodComponent,
    HeaderReminderComponent
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnChanges {
  @Input() clientId!: string;
  readonly SITE_LINKS = SITE_LINKS;

  isLoggedIn = false;

  constructor(
    private storageService: StorageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.get(STORAGE.ACCESS_TOKEN);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientId']) {
      this.clientId = changes['clientId'].currentValue;
    }
  }

  goToHome() {
    this.router.navigateByUrl(buildUrl(SITE_LINKS.CLIENT.DETAILS, this.clientId));
  }
}
